
import React from 'react';
import { PeerOSDiagram } from './PeerOSDiagram';

export const PeerOSSection = () => {
    return (
        <section className="pt-24 pb-24 px-8 bg-white border-t border-slate-100 overflow-hidden">
            <div className="max-w-7xl mx-auto">
                <div className="grid lg:grid-cols-2 gap-16 items-center">

                    {/* Left Column: Text */}
                    <div className="flex flex-col items-start max-w-2xl">
                        <div className="inline-flex items-center space-x-2 mb-6">
                            <div className="w-2 h-2 bg-slate-900 rounded-full animate-pulse"></div>
                            <span className="text-slate-400 text-sm font-semibold uppercase tracking-wider">Core Product</span>
                        </div>
                        <div className="flex items-center gap-4 mb-6">
                            <h2 className="text-4xl md:text-5xl font-bold leading-tight tracking-tight">
                                <span className="text-slate-900">THE DUAL</span>
                                <span className="text-transparent ml-2" style={{ WebkitTextStroke: '1px #000' }}>HQ</span>
                            </h2>
                        </div>
                        <p className="text-xl text-slate-500 mb-4 leading-relaxed font-semibold">
                            The First Agent with Decision Intelligence
                        </p>
                        <p className="text-lg text-slate-500 mb-8 leading-relaxed">
                            Turn chaos into decisions. Don't just delegate. Replicate. Deploy instances of yourself to handle meetings, negotiation, and deep work with your exact judgment.
                        </p>

                        <div className="grid md:grid-cols-2 gap-8 mb-10 w-full">
                            <div className="border-l-2 border-slate-200 pl-6">
                                <h3 className="font-semibold text-slate-900 mb-1">Dual Memory</h3>
                                <p className="text-slate-500">Never explain yourself twice. Records your decision history and learns your judgment patterns.</p>
                            </div>
                            <div className="border-l-2 border-slate-200 pl-6">
                                <h3 className="font-semibold text-slate-900 mb-1">Scale Yourself</h3>
                                <p className="text-slate-500">Deploy The Twin, The Proxy, and The Scout—AI agents that work with your reasoning style.</p>
                            </div>
                        </div>
                        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                            <a 
                                href="https://dualapp.thinkarc.ai" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="inline-block bg-slate-900 text-white px-8 py-3 rounded-md text-sm font-semibold hover:bg-slate-800 transition-colors duration-200"
                            >
                                Visit The Dual HQ
                            </a>
                        </div>
                    </div>

                    {/* Right Column: Schematic Diagram */}
                    <div className="w-full flex flex-col items-center lg:items-end">
                        <PeerOSDiagram />
                        <div className="mt-4 text-center lg:text-right">
                            <div className="text-[10px] font-mono font-bold text-slate-400 uppercase tracking-[0.2em]">
                                The Dual HQ - Decision Intelligence
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};
